<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Set Course Planner</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <v-autocomplete dense required v-model="course" :items="course_list" item-text="name" item-value="id"
              label="Course/Subject" outlined rounded persistent-hint
              hint="Please Select Course/Subject"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete dense required v-model="instructor" :items="instructor_list" item-text="name"
              item-value="id" label="Planner" outlined rounded persistent-hint hint="Please Select Planner"
              multiple></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" v-if="course && instructor.length >0">
            <v-btn @click="setCoursePlanner()" :loading="loader" color="info">save</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="course_planner_list!=''">
        <v-data-table :headers="headers" :items="course_planner_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Course Planners</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.isactive`]="{ item }">
            <v-switch v-model="item.isactive" small color="success" @change="toggleisactive(item)"></v-switch>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      loader:false,
      snackbar_msg: "",
      extraBreadcrumbItems: [


      ],
      breadcrumbClass: "breadcrumb-style1",
      color: "",
      snackbar: false,
      overlay: false,
      title:"",
      description:"",
      headers:[
      { text: "Course", value: "course" },
      { text: "Planner", value: "planner" },
      { text: "Assigned Date", value: "assigned_date" },
      { text: "Isactive", value: "isactive" },
      ],
      course_planner_list:[],instructor_list:[],course_list:[],course:"",instructor:[]
  }),
   methods: {
     async toggleisactive(item) {
      const formData = {
                    planner_id: item.id,
                    isactive: item.isactive,
                };
      try {
          const res = await axios.post("/LessonPlanning/toggleCoursePlanner",formData);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Updated Successfully..."); // show snackbar
            this.course_planner_list=res.data.course_planner_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
        this.course='',this.instructor=[]
      }
     
    },
     async setCoursePlanner() {
      const formData = {
                    course: this.course,
                    instructor: this.instructor,
                };
      try {
          const res = await axios.post("/LessonPlanning/setCoursePlanner",formData);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Added Successfully..."); // show snackbar
            this.course_planner_list=res.data.course_planner_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
        this.course='',this.instructor=[]
      }
     
    },
    async onLoad() {
      try {
          const res = await axios.post("/LessonPlanning/getCoursePlannerList");
          if (res.data.flag == "YES") {
            this.instructor_list=res.data.instructor_list
            this.course_list=res.data.course_list
            this.course_planner_list=res.data.course_planner_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>